import {
  TOUR_ICON_ALLOWED_TYPES,
  TOUR_ICON_MAX_BYTES,
} from "../constants/monetization";

/**
 * Lit les dimensions réelles du fichier.
 * L'objectURL est révoqué dans tous les cas pour ne pas fuiter le blob.
 */
const readImageSize = (file) =>
  new Promise((resolve) => {
    const objectUrl = URL.createObjectURL(file);
    const image = new Image();

    image.onload = () => {
      URL.revokeObjectURL(objectUrl);
      resolve({ width: image.naturalWidth, height: image.naturalHeight });
    };
    image.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      resolve(null);
    };
    image.src = objectUrl;
  });

/**
 * Valide l'icône avant envoi : type, poids, puis format carré.
 * Renvoie { errorKey } si le fichier est refusé, sinon { size }.
 */
export const validateTourIcon = async (file) => {
  if (!file) return { errorKey: "tour_email_icon.error.no_file" };

  if (!TOUR_ICON_ALLOWED_TYPES.includes(file.type)) {
    return { errorKey: "tour_email_icon.error.invalid_type" };
  }

  if (file.size > TOUR_ICON_MAX_BYTES) {
    return { errorKey: "tour_email_icon.error.too_large" };
  }

  const size = await readImageSize(file);

  // Un fichier au bon type MIME mais illisible existe : mieux vaut le refuser
  // ici que laisser le back renvoyer une erreur opaque.
  if (!size) return { errorKey: "tour_email_icon.error.unreadable" };

  if (size.width !== size.height) {
    return { errorKey: "tour_email_icon.error.not_square" };
  }

  return { size };
};

export default validateTourIcon;
